<template>
  <section class="settings-view">
    <h1 class="settings-view__title">My Settings</h1>
    <div class="settings-view__header">{{ organization.name }}</div>

    <tabs :options="{ useUrlFragment: false }" id="settings-tabs" class="voxy-tabs">
      <tab id="profile-settings" name="My Profile Settings">
        <profile-settings v-bind="{ profile }"></profile-settings>
      </tab>
      <tab id="manage-learners-report-downloads" name="Downloaded Reports">
        <h2 id="manage-learners-report-downloads-note">Reports downloaded in the last 24 hours</h2>
        <manage-learners-report-downloads></manage-learners-report-downloads>
      </tab>
      <tab
        v-if="showScheduledActivationsTab"
        id="scheduled-activations"
        name="Scheduled Activations"
        test-id="scheduled-activations-tab"
      >
        <h2 id="scheduled-actions-note">Scheduled activations requested by you</h2>
        <scheduled-activations></scheduled-activations>
      </tab>
    </tabs>
  </section>
</template>

<script>
import { mapGetters } from 'vuex';
import { Tabs, Tab } from 'vue-tabs-component';

import ProfileSettings from './components/ProfileSettings';
import ManageLearnersReportDownloads from './components/ManageLearnersReportDownloads';
import ScheduledActivations from './components/ScheduledActivations';

export default {
  name: 'SettingsView',

  components: {
    ScheduledActivations,
    ManageLearnersReportDownloads,
    ProfileSettings,
    Tabs,
    Tab,
  },

  beforeMount() {
    this.$store.dispatch('FETCH_ORGANIZATIONS');
  },

  computed: {
    ...mapGetters({
      profile: 'userProfile',
      organizations: 'organizations',
    }),

    ...mapGetters(['organizationId', 'featureGroupIds', 'canCreateUsersInSomeGroups', 'canCreateUsers']),

    showScheduledActivationsTab() {
      const canCreateUsers =
        this.canCreateUsers(this.organizationId) || this.canCreateUsersInSomeGroups(this.featureGroupIds);
      return canCreateUsers;
    },

    organization() {
      if (!this.profile.organization) {
        return {};
      }

      const organizationId = this.profile.organization.id;

      return this.organizations.find(organization => organization.id === organizationId) || {};
    },
  },
};
</script>

<style lang="scss">
@import '~styles/tools/mixins';

.settings-view {
  font-size: 12px;

  @include container();

  &__title {
    font-size: 3em;
    font-weight: 500;
    margin-top: 0;
    margin-bottom: 13px;
    text-transform: capitalize;
  }

  &__header {
    font-size: 36px;
    font-weight: 500;
    margin-bottom: 56px;
  }
}

.settings-section {
  padding-left: 25px;

  &__label {
    font-size: 18px;
    font-weight: 500;
    text-transform: uppercase;
    margin-bottom: 8px;
  }

  &__value {
    font-size: 15px;
    font-weight: 500;
    margin: 0 0 28px;
  }
}
</style>
